'use strict';
const angular = require('angular');

export class assetUploadComponent {
  /*@ngInject*/
  constructor(Upload, Auth, Config) {
    this.Upload = Upload;
    this.Auth = Auth;
    this.isAdmin = this.Auth.isAdminSync;
    this.singleFileUpload = false;

    this.tags = [{text: 'upload'}];

    this.roles = Config.getPlatformConfig().getPermissionRoles();
    this.defaultUploadUserPermission = Config.getPlatformConfig().getDefaultPermissionUserUpload();
  }

  hasPermissionOptions() {
    // No options, because it is always public anyway
    if (this.config && this.config.forcePublic)
      return false;

    // If there is more than one role available, then the admin has a choice
    if (this.roles.length > 1)
      return true;

    // If there is only one role, but this is for whatever reason not the default upload permission role,
    // then also give the admin the "choice"
    if (this.roles[0] != this.defaultUploadUserPermission[0])
      return true;

    // Otherwise, there is no option
    return false;
  }

  $onInit = function () {
    this.config = this.resolve.config;

    if (this.config.singleFileUpload)
      this.singleFileUpload = true;
  };

  ok() {
    this.close({$value: this.storageIds});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

  isImageMime(mime) {
    return mime.startsWith('image/');
  }

  isPdfMime(mime) {
    return mime === 'application/pdf';
  }

  isHtmlMime(mime) {
    return mime == 'text/html';
  }

  selectFiles(files) {
    this.files = files;

    if (this.config.forcePublic) {
      this.files.forEach(file => {
        file.isPublic = true;
        file.permissionModel = {};
      });
    }
    else if (this.isAdmin() && this.hasPermissionOptions()) {
      this.files.forEach(file => {
        file.isPublic = false;
        file.permissionModel = {};

        this.roles.forEach(role => {
          file.permissionModel[role] = this.defaultUploadUserPermission.includes(role);
        });
      });
    } else {
      this.files.forEach(file => {
        file.isPublic = false;
        file.permission = this.defaultUploadUserPermission;
      });
    }

  }

  uploadFiles() {
    let files = this.files;

    this.storageIds = [];
    this.allDone = false;
    this.progress = 0;

    var that = this;

    if (files && files.length) {

      var count = 0;

      files.forEach(file => {

        let permission = file.permission || [];

        // Check if we need to force public upload e.g. for mailblast
        if (this.config.forcePublic) {
          file.isPublic = true;
        }

        // An admin can change the permission, whereas a normal user always sets the
        // default permission, so that there is nothing to do here
        if (this.isAdmin() && this.hasPermissionOptions()) {
          // Permission is empty when file is public
          permission = [];

          // ... otherwise we have to build the array with permission roles from the model
          if (!file.isPublic) {
            for (let role in file.permissionModel) {
              if (file.permissionModel.hasOwnProperty(role)) {
                if (file.permissionModel[role] === true){
                  permission.push(role);
                }
              }
            }
          }
        }

        let _TAGS = this.tags.map(tag => tag.text);

        this.Upload.upload({
          url: '/api/storage',
          data: {
            name: file.name,
            file: file,
            isPublic: file.isPublic,
            permission: permission.join(','),
            tags: _TAGS.join(','),
            storageStrategy: 'local',
            creationUser: this.Auth.getCurrentUserSync()._id,
            active: true
          }
        }).then(function (response) {
          that.storageIds.push(response.data);

          count++;

          that.progress = Math.floor(count / files.length) * 100;

          if (count === files.length) {
            that.allDone = true;
            that.progress = 100;

            that.ok();
          }

        }, function (response) {
          if (response.status > 0) {
            alert(response.status + ': ' + response.data);
          }
        });

      });

    }
  };

}

export default angular.module('conduu.sm.asset.upload', [])
  .component('assetUpload', {
    template: require('./asset-upload.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: assetUploadComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/~sm/components/asset/upload/asset-upload.component.js